<template>
    <vx-card :title='$t("OpenTasks")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" search :data="open_tasks">

            <template slot="thead">
                <vs-th sort-key="task_company">{{$t("Client")}}</vs-th>
                <vs-th sort-key="task_name">{{$t("TaskTitle")}}</vs-th>
                <vs-th sort-key="user">{{$t("User")}}</vs-th>
                <vs-th sort-key="start_time">{{$t("StartTime")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].task_company">
                        {{ data[index].task_company }}
                    </vs-td>

                    <vs-td :data="data[index].task_name">
                        {{ data[index].task_name }}
                    </vs-td>

                    <vs-td :data="data[index].user">
                        {{ data[index].user }}
                    </vs-td>

                    <vs-td :data="data[index].start_time">
                        {{ moment(data[index].start_time).format('DD/MM/YYYY HH:mm') }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>
    </vx-card>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                open_tasks: [],
            }
        },
        methods: {
            handleSelected(tr) {
                this.$router.push({ name: 'task', params: { id: "" + tr.task_id} })
            },
            updateOpenTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/company/tasks/open')
                    .then(function (response) {
                        thisIns.open_tasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        created() {
            this.updateOpenTasks()
        },
    }
</script>
